<template>
  <router-link :to="link || ''">
    <div :class="['dashboard-widget', widgetBackgroundClass]">
      <div class="widget-icon">
        <i :class="['fa', icon, 'fa-fw']"></i>
      </div>
      <div class="widget-content">
        <Spinner v-if="loading" />
        <transition name="fade">
          <div v-if="!loading">
            <div :class="['widget-title', (!hasSlotContent && !loading) ? 'widget-title-large': '']">{{title}}</div>
            <div class="widget-preview-value">
              <slot name="value" />
            </div>
            <div class="widget-preview-sub-value"><slot name="subValue" /></div>
            <div class="widget-link" v-if="linkTitle"><i class="fa fa-search"></i> {{linkTitle}}</div>
          </div>
        </transition>
      </div>
    </div>
  </router-link>
</template>

<style scoped>
.dashboard-widget {
  position: relative;
  border-radius: 5px;
  padding: 15px 20px;
  margin-bottom: 10px;
  margin-top: 10px;
  color: #ffffff;
  overflow: hidden;
  min-height: 125px;
  max-height: 125px;
}
.widget-bg1 { background-color: #348fe2; }
.widget-bg2 { background-color: #7F43D5; }
.widget-bg3 { background-color: #269e58; }
.widget-bg4 { background-color: #f0932b; }
.widget-bg5 { background-color: #c23616; }
.widget-bg6 { background-color: #8c7ae6; }
.widget-bg7 { background-color: #487eb0; }
.widget-bg8 { background-color: #B33771; }
.widget-bg9 { background-color: #20bac5; }
.widget-bg10 { background-color: #34495e; }
.widget-bg11 { background-color: #4b6584; }
.widget-bg12 { background-color: #7f8fa6; }

.widget-icon {
  font-size: 128px;
  top: 15px;
  right: 0;
  color: #fff;
  width: 128px;
  height: 50px;
  line-height: 50px;
  text-shadow: 3px 7px rgba(0,0,0,.25);
  opacity: .15;
  text-align: center;
  position: absolute;
  margin-left: 15px;
}
.widget-content {
  position: relative;
}
.widget-title {
  font-size: 14px;
  margin: 0px 0px 2px;
  text-transform: uppercase;
}
.widget-title-large {
  font-size: 20px;
  text-transform: none;
}
.widget-preview-value {
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 1px;
  margin: 0;
}
.widget-preview-sub-value {
  font-size: 12px;
  margin: -5px 0 0 0;
  color: rgba(255, 255, 255, 0.8);
}
.widget-link {
  position: absolute;
  top: 80px;
  left: 0px;
}
.widget-link {
  color: rgba(255, 255, 255, 0.7);
}
.widget-link a:hover {
  text-decoration: underline;
}
</style>

<script>
export default {
  name: 'DashboardWidget',
  props: {
    title: String,
    link: String,
    linkTitle: String,
    icon: String,
    previewValue: [String, Number],
    previewSubValue: String,
    widgetBackgroundClass: {
      type: String,
      default: 'widget-bg1'
    },
    loading: Boolean
  },
  data() {
    return {
      hasSlotContent: true,
    }
  },
  methods: {
    checkForSlotContent() {
      let checkForContent = (hasContent, node) => {
        return hasContent || node.tag || (node.text && node.text.trim())
      }
      return this.$slots.value && this.$slots.value.reduce(checkForContent, false)
    }
  },
  beforeUpdate() {
    this.hasSlotContent = this.checkForSlotContent()
  },
  created() {
    this.hasSlotContent = this.checkForSlotContent()    
  }
}
</script>